import _Object$values from "babel-runtime/core-js/object/values";
var kotlinListToJsArray = function kotlinListToJsArray(kotlinList) {
  var values = _Object$values(kotlinList);
  for (var i = 0; i < values.length; i++) {
    if (Array.isArray(values[i])) {
      return values[i];
    }
  }
  return [];
};

var kotlinLongToDate = function kotlinLongToDate(kotlinLong) {
  return new Date(kotlinLong.toNumber());
};

export { kotlinListToJsArray, kotlinLongToDate };